import { useFormContext } from 'react-hook-form';

import { CPDEnrollmentStatusEnum, CPDLicenseTypeEnum, ICPDLicense, CPDRegulatorTypeEnum } from '../../../../interfaces';

import LicenseForm from '@components/molecules/cpdEnrollment/licenseInformation/licenseForm';
import { CPDEnrollmentFieldNames } from 'src/helpers/constants';
import { dateFormatThai, getLicenseFieldNames } from 'src/helpers/utils';

type Props = {
  courseLicenseType: CPDLicenseTypeEnum;
  customerLicenses: ICPDLicense[];
};

const OICLicenseRenewalForm = ({ courseLicenseType, customerLicenses }: Props) => {
  const { getValues } = useFormContext();

  const customerLicense = customerLicenses?.find((license) => license.licenseType === courseLicenseType);

  const licenseFormFlag = getValues(CPDEnrollmentFieldNames.status) !== CPDEnrollmentStatusEnum.RegulatorUnChecked;

  const licenseName = courseLicenseType === CPDLicenseTypeEnum.LIFE ? 'Life' : 'NonLife';
  const { licenseNoFieldName, licenseStartDateFieldName, licenseEndDateFieldName } = getLicenseFieldNames(licenseName);

  return (
    <>
      <LicenseForm
        licenseFieldName={licenseNoFieldName}
        startDateFieldName={licenseStartDateFieldName}
        endDateFieldName={licenseEndDateFieldName}
        license={customerLicense?.licenseNo}
        startDate={customerLicense?.createdDate ? dateFormatThai(customerLicense?.createdDate!) : undefined}
        endDate={customerLicense?.expiredDate ? dateFormatThai(customerLicense?.expiredDate!) : undefined}
        disabled={licenseFormFlag}
      />
    </>
  );
};

export default OICLicenseRenewalForm;
